<template>
    <div :class="[isJACareerEntrepreApp ? 'arrow-green-dark' : 'arrow-green-light']" class="carousel-wrapper box-shadowed background-white">
        <div class="carousel" @mousedown="slideStart" @mouseup="slideEnd" @touchstart="slideStart" @touchend="slideEnd"
             ref="carousel">
            <slot/>
        </div>
        <div role="region" id="slides-section" class="sr-only" aria-live="polite">
            slide {{ currentSlide + 1 }} of {{ totalSlides }}
        </div>
        <div class="d-flex flex-row justify-content-between button-bar" aria-controls="slides-section">
            <div class="carousel-button" tabindex="-1">
                <a v-if="currentSlide !== 0"
                   @click="changeSlide(-1)"
                   @keypress.enter.space="changeSlide(-1)"
                   tabindex="0" role="button" aria-label="Previous">
                    <img class="icon-arrow-2" alt="Previous">
                </a>
            </div>
            <div class="d-flex flex-row align-items-center">
                <div v-for="(slide, index) in Array.from(Array(totalSlides).keys())"
                     :key="index" :class="slide === currentSlide ? 'carousel-step-current': 'carousel-step'">
                </div>
            </div>
            <div class="d-flex flex-row justify-content-end carousel-button">
                <a v-if="currentSlide !== (totalSlides - 1)"
                   @click="changeSlide(1)"
                   @keypress.enter.space="changeSlide(1)"
                   tabindex="0" role="button" aria-label="Next">
                    <img class="icon-arrow-1" alt="Next">
                </a>
                <a v-else tabindex="0" role="button" aria-label="Done"
                   @click="done()" @keypress.enter.space="done()"
                  >
                    Done
                    <img class="icon-arrow-1" alt="Done">
                </a>
            </div>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue'
    import CarouselItem from "./CarouselItem"
    import project from "../../../core/Utils/project";

    export default {
        name: "Carousel",
        data() {
            return {
                x0: null,
                y0:null,
                slides: [],
                currentSlide: 0,
                totalSlides: null
            }
        },
        updated() {
            this.$nextTick(() => {
                if (this.totalSlides === null) {
                    this.slides = this.$slots.default.filter(
                        item => item.componentOptions && item.componentOptions.Ctor === Vue.extend(CarouselItem)
                    )
                    this.totalSlides = this.slides.length
                }
                for (let index = 0; index < this.totalSlides; index++) {
                    this.slides[index].componentInstance.active = index === this.currentSlide
                }
            })
        },
        methods: {
            unify(e) {
                return e.changedTouches ? e.changedTouches[0] : e
            },
            slideStart(e) {
                this.x0 = this.unify(e).clientX
                this.y0 = this.unify(e).clientY
                const carousel = this.$refs.carousel
                this.scrollLeft = carousel.scrollLeft
            },
            slideEnd(e) {
                if (!this.x0 || !this.y0) {
                    return;
                }

                const xUp = this.unify(e).clientX;
                const yUp = this.unify(e).clientY;

                const xDiff = this.x0 - xUp;
                const yDiff = this.y0 - yUp;

                if (Math.abs(xDiff) > Math.abs(yDiff)) {
                    const delta = Math.sign(xDiff);
                    this.changeSlide(delta)
                }

                this.x0 = null;
                this.y0 = null;
            },
            done() {
                this.$emit('done')
            },
            changeSlide(delta) {
                const nextSlide = this.currentSlide + delta
                if (nextSlide >= 0 && nextSlide < this.totalSlides) {
                    const carousel = this.$refs.carousel
                    const width = carousel.offsetWidth
                    carousel.scrollTo(carousel.scrollLeft + width * delta, 0)
                    this.currentSlide = nextSlide
                }
            }
        }
    }
</script>


<style scoped lang="stylus">
    @import "~@/core/Styles/variables.styl"

    .high-contrast
        .icon-arrow-1
            content url("../Images/ico_arrow_1_high_contrast.svg")

        .icon-arrow-2
            content url("../Images/ico_arrow_2_high_contrast.svg")

        .button-bar
            color color-29

    .arrow-green-dark
        .icon-arrow-1
            content url("../Images/ico_arrow_1_dark.svg")

        .icon-arrow-2
            content url("../Images/ico_arrow_2_dark.svg")

    .arrow-green-light
        .icon-arrow-1
            content url("../Images/ico_arrow_1.svg")

        .icon-arrow-2
            content url("../Images/ico_arrow_2.svg")

    .btn-secondary
        background-color #f4f6f6
        border none

    .carousel-wrapper
        border-radius 25px

    .carousel
        display flex
        align-items flex-start
        width 100%
        min-height calc(100vh - 195px)
        scroll-behavior smooth
        scroll-snap-type x mandatory

        & > *
            flex: 1 0 100%
            scroll-snap-align start
            pointer-events none

    .button-bar
        font-family font-poppins-semibold
        font-size 16px
        color color-5
        letter-spacing 0.8px
        padding-left 20px
        padding-right 20px
        padding-bottom 25px

    .carousel-button
        width 40px
        display flex
        align-items flex-end
        a
            width 40px

    .arrow-green-dark
        a
            color color-green-light
            &:hover
                color color-green-dark

    .carousel-step, .carousel-step-current
        display inline-block
        margin 0 5px
        border-radius 50%

    .carousel-step
        width 5px
        height 5px
        background-color color-4

    .carousel-step-current
        width 7px
        height 7px
        background-color color-9
</style>
